import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InfoOverlay from '../../../components/InfoOverlay';

function StartlistCard({
  startlistItem,
  status,
  setChosenParticipant,
  onRemove,
  onEdit,
  setBatchSelectedParticipants,
  batchSelectedParticipants,
}) {
  return (
    <Card>
      <Card.Body>
        <div className='d-none d-sm-flex gap-2 align-items-center justify-content-between'>
          <div className='d-flex align-items-center'>
            <span className='bg-secondary-black text-white p-1 me-2'>
              {startlistItem.racingNumber}
            </span>
            <InfoOverlay
              name={startlistItem.name}
              info={startlistItem.participantDetails}
              unRegistered={startlistItem.unRegistered}
              participantInfo={true}
            />
          </div>
          <div className='d-flex gap-1'>
            <span className='me-2 text-secondary'>Tävlingsklass</span>
            <span>
              {startlistItem.raceClassString
                ? startlistItem.raceClassString === 'women'
                  ? 'Dam'
                  : startlistItem.raceClassString.charAt(0).toUpperCase() +
                  startlistItem.raceClassString.slice(1)
                : 'Ej angett'}
            </span>
          </div>
        </div>
        <div className='d-flex d-sm-none gap-2 align-items-center justify-content-between'>
          <div className='d-flex align-items-center'>
            <span className='bg-secondary-black text-white p-1 me-2'>
              {startlistItem.racingNumber}
            </span>
            <InfoOverlay
              name={startlistItem.name}
              info={startlistItem.participantDetails}
              unRegistered={startlistItem.unRegistered}
              participantInfo={true}
            />
          </div>
        </div>
        <div className='d-flex d-sm-none justify-content-between pt-2'>
          <span className='text-secondary'>Tävlingsklass</span>
          <span>
            {startlistItem.raceClassString
              ? startlistItem.raceClassString === 'women'
                ? 'Dam'
                : startlistItem.raceClassString.charAt(0).toUpperCase() +
                startlistItem.raceClassString.slice(1)
              : 'Ej angett'}
          </span>
        </div>
        <div className='d-flex justify-content-between pt-2'>
          <span className='text-secondary'>Klubb</span>
          <span>
            {startlistItem.clubAffiliation
              ? startlistItem.clubAffiliation
              : 'Ej angett'}
          </span>
        </div>
        <div className='d-flex justify-content-between pt-2'>
          <span className='text-secondary'>Godkänd besiktning</span>
          {startlistItem.approvedInspection ? (
            <span className='bg-success p-1'>Ja</span>
          ) : (
            <span className='bg-danger p-1'>Nej</span>
          )}
        </div>
        <Card.Footer className='mt-2'>
          <div className='d-flex justify-content-between flex-wrap'>
            <div className='d-flex gap-2 align-items-center'>
              <input
                id={startlistItem.racingNumber}
                type='checkbox'
                checked={batchSelectedParticipants.some(
                  (p) => p.racingNumber === startlistItem.racingNumber
                )}
                disabled={status !== 'Kommande' && status !== 'Pågående'}
                onChange={() => {
                  let newArr = [...batchSelectedParticipants];

                  if (
                    newArr.some(
                      (p) => p.racingNumber === startlistItem.racingNumber
                    )
                  ) {
                    newArr = newArr.filter(
                      (p) => p.racingNumber !== startlistItem.racingNumber
                    );
                  } else {
                    newArr = [...newArr, startlistItem];
                  }

                  setBatchSelectedParticipants(newArr);
                }}
              />
              <label htmlFor={startlistItem.racingNumber}>Markera</label>
            </div>

            {status === 'Avslutad' ? (
              <Button
                variant='outline-primary'
                className='d-flex align-items-center'
                disabled
              >
                <span className='material-symbols-outlined me-2'>delete</span>
                Ta bort
              </Button>
            ) : (
              <div className='d-flex gap-2 flex-wrap'>
                <Button
                  variant='outline-primary'
                  className='d-flex align-items-center'
                  onClick={() => {
                    if (status !== 'Avslutad') {
                      setChosenParticipant({ id: startlistItem.participantId, racingNumber: startlistItem.racingNumber, raceClassString: startlistItem.raceClassString, email: startlistItem.participantDetails.email })
                      onEdit();
                    }
                  }}
                  disabled={status === 'Avslutad'} // {status === 'Avslutad' || startlistItem.numberSetManually}
                >
                  <span className='material-symbols-outlined me-2'>edit</span>
                  Redigera startnummer
                </Button>
                <Button
                  variant='outline-primary'
                  className='d-flex align-items-center'
                  onClick={() => {
                    setChosenParticipant({ id: startlistItem.participantId, racingNumber: startlistItem.racingNumber, raceClassString: startlistItem.raceClassString, email: startlistItem.participantDetails.email })
                    onRemove();
                  }}
                >
                  <span className='material-symbols-outlined me-2'>delete</span>
                  Ta bort
                </Button>
              </div>
            )}
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default StartlistCard;
